import Component from "./component"
import Header from "./header"
import { HistoricalFactorSensitivityContext, PredictedFactorSensitivityContext } from "./context"

export const historical = {
  Component,
  Header,
  Context: HistoricalFactorSensitivityContext,
}

export const predicted = {
  Component,
  Header,
  Context: PredictedFactorSensitivityContext,
}
